<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        sm="4"
      >
        <v-select
          v-model="query.slug"
          :items="slugList"
          item-text="name"
          item-value="slug"
          label="เลือกประเภทเกมส์"
          outlined
        />
      </v-col>
      <v-spacer />
      <v-col
        cols="12"
        sm="4"
      >
        <v-menu
          ref="showDateDialog"
          v-model="showDateDialog"
          :close-on-content-click="false"
          :return-value.sync="dateSelect"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="dateSelectDisplay"
              prepend-icon="mdi-calendar"
              outlined
              v-bind="attrs"
              hide-details
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="dateSelect"
            no-title
            @change="
              $refs.showDateDialog.save(dateSelectDisplay);
              showDateDialog = false;
            "
          />
        </v-menu>
      </v-col>
      <v-spacer />
      <v-col
        cols="12"
        sm="2"
        offset-sm="1"
      >
        <div class="d-flex align-items-baseline my-2">
          <v-btn
            color="primary"
            @click="getReportGame()"
          >
            <v-icon left>
              mdi-check
            </v-icon>
            ค้นหา
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <div
      v-for="(item, index) in dataResult"
      v-if="index != 'constants'"
      :key="item.id"
      class="mt-5"
    >
      <div class="card">
        <div class="card-header">
          {{ index }}
        </div>
        <div class="card-body">
          <v-simple-table>
            <template #default>
              <thead>
                <tr class="bg-dark">
                  <th
                    class="bg-dark text-center text-light"
                    width="30%"
                  >
                    ประเภท
                  </th>
                  <th
                    class="bg-dark text-center text-light"
                    width="20%"
                  >
                    ยอดแทง
                  </th>
                  <th
                    class="bg-dark text-center text-light"
                    width="20%"
                  >
                    ยอดถูก
                  </th>
                  <th
                    class="bg-dark text-center text-light"
                    width="30%"
                  >
                    เหลือ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="slug in item"
                  :key="slug.number_slug"
                >
                  <td>
                    {{ dataResult.constants[slug.number_slug] }}
                  </td>
                  <td
                    align="center"
                    class="text-success text-right"
                  >
                    {{ Number(slug.bet_amount).toLocaleString("en-US") }}
                  </td>
                  <td
                    align="center"
                    class="text-warning text-right"
                  >
                    {{
                      Number(slug.win_amount).toLocaleString("en-US", {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td
                    align="center"
                    :class="
                      slug.bet_amount - slug.win_amount > 0
                        ? 'text-right text-success'
                        : 'text-right text-danger'
                    "
                  >
                    {{
                      Number(slug.bet_amount - slug.win_amount).toLocaleString(
                        "en-US",
                        {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2,
                        }
                      )
                    }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
    </div>

    <v-dialog
      v-if="preload"
      v-model="preload"
      persistent
      width="500"
      max-width="100vw"
    >
      <v-card class="pa-md-10 mx-lg-auto">
        <v-container class="text-center">
          <v-progress-circular
            :size="100"
            :width="10"
            indeterminate
            color="primary"
          />
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from 'moment-timezone';

export default {
  name: 'ReportGameDaily',
  props: {
    slugList: { default: '', Type: Array },
  },
  data: () => ({
    preload: false,
    showDateDialog: false,
    dateSelect: moment().format('YYYY-MM-DD'),
    query: {
      slug: 'soidown',
    },
    dataResult: [],
  }),
  computed: {
    dateSelectDisplay() {
      return this.dateSelect;
    },
  },
  watch: {},
  methods: {
    getReportGame() {
      this.preload = true;

      axios
        .get('/api/report/game/daily', {
          params: {
            slug: this.query.slug == null ? 'soidown' : this.query.slug,
            dateReport: this.dateSelect,
          },
        })
        .then((response) => {
          this.dataResult = response.data;
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.preload = false;
        });
    },
  },
};
</script>
